import {Link} from 'react-router-dom'

/**
 * Types and Interface
 */
import {DefaultComponentProps} from '@interface/common'

/**
 * Helpers
 */
import {pure} from '@react/store'

/**
 * Components
 */
import Header from './header'
import Button from '@components/button'

/**
 * Assets
 */
import './auth.scss'


/**
 * Login Screen
 */
export default pure(({store}: DefaultComponentProps) => {
  const state = store.useLocalState({
    email: null,
  })
  const auth = store.get('auth')


  return (
    <div id="auth">
      <Header/>
      <div className="box">
        <h1 className="strip">Request Reset Password</h1>
        <p style={{marginBottom: 20}}>Enter your email address and we will send you the instruction.</p>

        {auth.status.error && (
          <p className="error">{auth.status.error}</p>
        )}
        {auth.status.success && (
          <p className="success">{auth.status.success}</p>
        )}
        
        <form
          id="form"
          onSubmit={(e) => {
            e.preventDefault()
            /**
             * Send request
             */
            store.dispatch({type: 'auth/forgot', data: {email: state.email}})
          }}>
          {/**
           * Fields 
           */}
          <div className="field">
            <label>
              <i className="icon-email"></i>
              <span>Email Address</span>
            </label>
            <input type="email" onChange={(e) => state.set({email: e.target.value})} placeholder="Enter your email address" required/>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}>
            <Link to="/" className="link">Back to Login</Link>
          </div>
          <div className="action">
            <Button
              preload={auth.status.preload}
              style={{
                width: '10%',
                alignSelf: 'center'
              }}
              label={'Submit'}
              className={'button-3'}
            />
          </div>
        </form>
      </div>
    </div>
  )
})